import Input, { InputProps } from 'antd/lib/input';
import React, { useEffect } from 'react';
import { getCommonStatus, ICommonProps } from './common';
import _ from 'lodash';
import { loadingWrapper } from '@/components/common/block-loading';

export type InputUploadValueType = FileList;
export interface IInputUploadOptions extends InputProps {}

export interface IWidgetInputUploadProps<T = any> extends ICommonProps<T> {
    value: InputUploadValueType;
    options: IInputUploadOptions;
    onChange: (val: InputUploadValueType) => void;
}

export const WidgetInputUpload: React.FC<IWidgetInputUploadProps> = ({
    value,
    options,
    onChange,
    status,
    onInteract = key => void 0,
    data,
    statusExtraData,
}) => {
    const { loading, disabled } = getCommonStatus(
        status,
        data,
        statusExtraData,
    );
    const wrapper = loadingWrapper(loading || false);

    if (disabled) {
        options.disabled = true;
    } else {
        options.disabled = false;
    }

    return wrapper(
        <Input
            {...options}
            type="file"
            onFocus={e => {
                onInteract('focus');
                onInteract('remove-validate-status');
            }}
            onBlur={e => {
                onInteract('blur');
                onInteract('validate-instantly');
            }}
            onChange={e => {
                if (e.target && !_.isNil(e.target.files)) {
                    onChange(e.target.files);
                }
            }}
        />,
    );
};
